import { createFileRoute } from '@tanstack/react-router';
import { usePageTitle } from '../../../lib/hooks';
import { PageHeader } from '../../../components/layout/PageHeader';

export const Route = createFileRoute('/_auth/settings/mpin')({
  component: MpinSettingsPage,
});

function MpinSettingsPage() {
  usePageTitle('MPIN Settings');
  return (
    <div className="max-w-md">
      <PageHeader
        title="MPIN"
        subtitle="Set up a 6-digit MPIN for the mobile app"
      />
      <p className="text-sm text-text-muted">MPIN configuration is available in the mobile app.</p>
    </div>
  );
}
